import React from 'react';
import { remCss, scssVariables as variables } from 'src/helpers';

const MedicalRecoveryIcon = React.memo(({ width = 81, height = 80, viewBox = '0 0 81 80' }) => (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width={remCss(width)}
    height={remCss(height)}
    viewBox={viewBox}
  >
    <path
      fill={variables['colors-mc-primary']}
      fillOpacity='0.1'
      stroke={variables['colors-mc-primary']}
      d='M79.9282 40C79.9282 61.8153 62.2435 79.5 40.4282 79.5C18.613 79.5 0.928223 61.8153 0.928223 40C0.928223 18.1848 18.613 0.5 40.4282 0.5C62.2435 0.5 79.9282 18.1848 79.9282 40Z'
    />
    <g clipPath='url(#clip0_414_10568)'>
      <path
        d='M40.8046 52.2077C47.5484 52.2077 53.0154 46.7408 53.0154 39.9969C53.0154 33.2531 47.5484 27.7861 40.8046 27.7861C34.0607 27.7861 28.5938 33.2531 28.5938 39.9969C28.5938 46.7408 34.0607 52.2077 40.8046 52.2077Z'
        fill='#FFD422'
      />
      <path
        d='M48.131 37.555V42.4393H43.2467V47.3236H38.3623V42.4393H33.478V37.555H38.3623V32.6707H43.2467V37.555H48.131Z'
        fill='#FF5023'
      />
      <path d='M41.6188 22.0879H39.9907V23.716H41.6188V22.0879Z' fill='#EE8700' />
      <path
        d='M28.7157 26.7572L27.5645 27.9084L28.7157 29.0597L29.8669 27.9084L28.7157 26.7572Z'
        fill='#EE8700'
      />
      <path d='M24.5236 39.1831H22.8955V40.8112H24.5236V39.1831Z' fill='#EE8700' />
      <path
        d='M28.7162 50.9347L27.5649 52.0859L28.7162 53.2372L29.8674 52.0859L28.7162 50.9347Z'
        fill='#EE8700'
      />
      <path d='M41.6188 56.2781H39.9907V57.9062H41.6188V56.2781Z' fill='#EE8700' />
      <path
        d='M52.8934 50.9344L51.7422 52.0857L52.8934 53.2369L54.0447 52.0857L52.8934 50.9344Z'
        fill='#EE8700'
      />
      <path d='M58.714 39.1831H57.0859V40.8112H58.714V39.1831Z' fill='#EE8700' />
      <path
        d='M52.8934 26.7572L51.7422 27.9084L52.8934 29.0597L54.0447 27.9084L52.8934 26.7572Z'
        fill='#EE8700'
      />
      <path
        d='M42.6859 17.285L43.8256 16.1454L42.6712 15L40.2291 17.4422C40.0765 17.5948 39.9907 17.8018 39.9907 18.0177C39.9907 18.2336 40.0765 18.4406 40.2291 18.5932L42.6712 21.0354L43.8223 19.8843L42.8723 18.9343C47.9473 19.4306 52.6725 21.7423 56.179 25.4444C59.6856 29.1466 61.7377 33.9902 61.9581 39.0846C62.1784 44.179 60.5522 49.1817 57.3784 53.1728C54.2047 57.1639 49.6967 59.875 44.6836 60.8076L44.9791 62.4089C50.4058 61.398 55.2814 58.4521 58.7003 54.1182C62.1192 49.7843 63.8493 44.3569 63.5691 38.8439C63.2889 33.3309 61.0176 28.1069 57.1769 24.142C53.3362 20.177 48.1872 17.7406 42.6859 17.285Z'
        fill='#FF9811'
      />
      <path
        d='M41.3801 61.401L38.9379 58.9588L37.7868 60.1099L38.7368 61.0599C33.5969 60.5573 28.818 58.1927 25.3003 54.4115C21.7826 50.6303 19.7687 45.6934 19.638 40.5306C19.5073 35.3677 21.2688 30.3352 24.5907 26.3809C27.9126 22.4266 32.5657 19.8232 37.6737 19.0612L37.4352 17.4478C31.9039 18.2717 26.8686 21.1003 23.2873 25.3954C19.7059 29.6905 17.8286 35.1522 18.0123 40.7415C18.1961 46.3307 20.4282 51.6574 24.2839 55.708C28.1396 59.7585 33.3498 62.2503 38.9233 62.7091L37.7836 63.8488L38.9347 64.9999L41.3768 62.5577C41.4535 62.4823 41.5144 62.3923 41.5561 62.2932C41.5977 62.194 41.6194 62.0876 41.6197 61.98C41.62 61.8725 41.5989 61.7659 41.5578 61.6665C41.5167 61.5671 41.4563 61.4769 41.3801 61.401Z'
        fill='#FF9811'
      />
    </g>
    <defs>
      <clipPath id='clip0_414_10568'>
        <rect width='50' height='50' fill='white' transform='translate(15.4282 15)' />
      </clipPath>
    </defs>
  </svg>
));
MedicalRecoveryIcon.displayName = 'MedicalRecoveryIcon';

export default MedicalRecoveryIcon;
